<p-dialog [focusOnShow]="false" [resizable]="true"  class="gs-ai-chat-dialog" header="Header" [(visible)]="visible" [modal]="true" [style]="{ width: isExpanded ? '1100px' : '380px', height: '600px', minWidth: '380px', maxHeight: '600px', minHeight: '600px' }">
    <ng-template pTemplate="header">
        <div class="inline-flex w-full">
            <div class="flex justify-between items-center w-full pr-6">
                <div class="flex items-center">
                    <svg-icon class="icon-40" src="/assets/icons/ai-avatar.svg"></svg-icon>
                    <p i18n="@@chatbot.bot.name" class="pl-2 font-600 text-16 text-black">Connie</p>
                </div>
                <div class="flex">
                    <svg-icon (click)="download()" class="icon-24 cursor-pointer" src="/assets/icons/chat-download.svg"></svg-icon>
                    @if (isExpanded) {
                        <svg-icon (click)="showExpanded()" class="icon-24 pl-4 cursor-pointer" src="/assets/icons/expanded.svg"></svg-icon>
                    } @else {
                        <svg-icon (click)="showExpanded()" class="icon-24 pl-4 cursor-pointer" src="/assets/icons/expand.svg"></svg-icon>
                    }
                </div>
            </div>
        </div>
    </ng-template>
    <div #scrollMe class="flex flex-col w-full overflow-y-auto p-3" style="height: 474px">
        <div class="flex flex-col justify-center items-center w-full">
            <svg-icon id="big-connie" src="/assets/icons/ai-avatar.svg"></svg-icon>
            <p i18n="@@chatbot.bot.ready" class="font-600 text-16 text-center px-6 py-3">Connie, our smart concierge bot, is ready to help.</p>
            <div class="flex flex-col w-full">
                <div class="flex justify-start w-full py-1 mt-10">
                    <p i18n="@@chatbot.bot.greeting" class="ml-8 bg-gray-100 p-2 rounded-lg font-600 text-12 chat-p" [ngClass]="{ 'chat-p-expand': isExpanded }">Hi </p> <p class=" bg-gray-100 rounded-lg font-600 text-12 chat-p">{{ userName }}</p>
                </div>
                <div class="flex justify-start w-full py-1">
                    <p i18n="@@chatbot.bot.intro" class="ml-8 bg-gray-100 p-2 rounded-lg text-12 font-600 chat-p" [ngClass]="{ 'chat-p-expand': isExpanded }">I’m your smart concierge bot, available to answer any questions you may have.</p>
                </div>
                <div class="flex justify-start w-full py-1">
                    <p i18n="@@chatbot.bot.prompt" class="ml-8 bg-gray-100 p-2 text-12 rounded-lg font-600 chat-p" [ngClass]="{ 'chat-p-expand': isExpanded }">Ask something or choose a common topic below:</p>
                </div>
                <!-- Default Options start here  -->
                <div class="flex flex-wrap gap-2 my-2 ml-8 chat-p" [ngClass]="{ 'chat-p-expand': isExpanded }">
                    @for (option of options; let index = $index; track index) {
                        <div class="flex justify-start items-start">
                            <button (click)="selectMain(index)" class="chat-options" [ngClass]="{ 'chat-selected': index === optionIndex }">
                                {{ option.name }}
                            </button>
                        </div>
                    }
                </div>

                @if (optionIndex !== undefined) {
                    <div class="flex justify-start w-full py-2">
                        <p class="ml-8 bg-gray-100 p-2 rounded-lg chat-p text-12" [ngClass]="{ 'chat-p-expand': isExpanded }">
                            What would you like to know about <br />
                            {{ options[optionIndex].name }}:
                        </p>
                    </div>
                    <div class="flex flex-col ml-8 chat-p" [ngClass]="{ 'chat-p-expand': isExpanded }">
                        @if (options && options[optionIndex]) {
                            @for (value of options[optionIndex].value; let index = $index; track index) {
                                <button (click)="selectOption(value)" class="value-options my-1 chat-p" [ngClass]="{ 'chat-p-expand': isExpanded }">
                                    {{ value }}
                                </button>
                            }
                        }
                    </div>
                }

                @for (chat of chatHistory; let index = $index; track index) {
                    @if (chat.role === "bot") {
                        <div class="flex justify-start items-end w-full py-1">
                            <svg-icon id="small-connie" class="icon-20" src="/assets/icons/ai-avatar.svg"></svg-icon>
                            <p class="ml-2 bg-gray-100 text-12 p-2 bot-content font-600 chat-p" [ngClass]="{ 'chat-p-expand': isExpanded }" [innerHTML]="chat.message"></p>
                        </div>
                    } @else {
                        <div class="flex justify-end w-full py-1">
                            <p class="user-chat text-12 user-content text-white p-2 font-600 chat-p" [ngClass]="{ 'chat-p-expand': isExpanded }">{{ chat.message }}</p>
                        </div>
                    }
                }
                @if (loading()) {
                    <div class="flex justify-start items-end w-full py-1">
                        <svg-icon id="small-connie" class="icon-20" src="/assets/icons/ai-avatar.svg"></svg-icon>
                        <div class="w-[60px] h-[30px] bg-gray-100 bot-content flex justify-center items-center ml-2">
                            <div class="dot-pulse"></div>
                        </div>
                    </div>
                }
                @if (errorOptions && errorOptions.length) {
                    <div class="flex flex-wrap gap-2 my-2 ml-8 chat-p" [ngClass]="{ 'chat-p-expand': isExpanded }">
                        @for (option of options; let index = $index; track index) {
                            <div class="flex justify-start items-start">
                                <button (click)="selectMain(index)" class="chat-options" [ngClass]="{ 'chat-selected': index === optionIndex }">
                                    {{ option.name }}
                                </button>
                            </div>
                        }
                    </div>
                    @if (optionIndex !== undefined) {
                        <div class="flex justify-start w-full py-2">
                            <p class="ml-8 bg-gray-100 p-2 rounded-lg chat-p text-12" [ngClass]="{ 'chat-p-expand': isExpanded }">
                                What would you like to know about <br />
                                {{ options[optionIndex].name }}:
                            </p>
                        </div>
                        <div class="flex flex-col ml-8 chat-p" [ngClass]="{ 'chat-p-expand': isExpanded }">
                            @if (options && options[optionIndex]) {
                                @for (value of options[optionIndex].value; let index = $index; track index) {
                                    <button (click)="selectOption(value)" class="value-options my-1 chat-p" [ngClass]="{ 'chat-p-expand': isExpanded }">
                                        {{ value }}
                                    </button>
                                }
                            }
                        </div>
                    }
                }
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="w-full">
            <input (keydown.enter)="enterPrompt()" type="text" placeholder="Enter message..." pInputText [(ngModel)]="prompt" />
        </div>
    </ng-template>
</p-dialog>
